<!-- Start Error Area -->
<div class="error-area">
    <div class="container">
        <div class="error-content">
            <img src="assets/img/404.png" alt="error">
            <h3>Services coming Soon</h3>
            <!-- <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p> -->
            <a href="/" class="btn btn-primary">Go to Home</a>
        </div>
    </div>
</div>
<!-- End Error Area -->